import React from 'react';

import { studioIcon } from '@atlaskit/logo/raw-icons';

/** Decorative product icon accompanying the localized Studio attribution name. */
export const StudioAttributionIcon = (): React.JSX.Element => (
	<img src={studioIcon} alt="" width={16} height={16} />
);
